
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"103","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 4a4 4 0 014-4h99l-8.306 13L103 26H0V4z","fill":"#FA507B"}}),_c('path',{attrs:{"d":"M16.82 8.136V18h2.065v-3.11h1.845c2.079 0 3.521-1.354 3.521-3.377 0-2.03-1.395-3.377-3.418-3.377H16.82zm2.065 1.634h1.401c1.183 0 1.866.628 1.866 1.75 0 1.128-.69 1.756-1.873 1.756h-1.394V9.77zm11.24-1.805c-2.926 0-4.758 1.962-4.758 5.106 0 3.138 1.832 5.1 4.758 5.1 2.919 0 4.758-1.962 4.758-5.1 0-3.144-1.84-5.106-4.758-5.106zm0 1.723c1.613 0 2.645 1.312 2.645 3.383 0 2.065-1.032 3.37-2.645 3.37-1.62 0-2.652-1.305-2.652-3.37 0-2.071 1.039-3.383 2.652-3.383zm6.29-1.552V18h2.065v-3.11h1.846c2.078 0 3.52-1.354 3.52-3.377 0-2.03-1.394-3.377-3.418-3.377h-4.012zM38.48 9.77h1.401c1.183 0 1.867.628 1.867 1.75 0 1.128-.69 1.756-1.873 1.756H38.48V9.77zm8.854-1.634H45.27v6.378c0 2.174 1.606 3.657 4.136 3.657 2.522 0 4.129-1.483 4.129-3.657V8.136H51.47v6.173c0 1.264-.745 2.091-2.064 2.091-1.326 0-2.072-.827-2.072-2.091V8.136zM61.76 16.29h-4.313V8.136h-2.065V18h6.378v-1.709zM69.644 18h2.194l-3.432-9.864H65.98L62.556 18h2.119l.752-2.393h3.466L69.644 18zm-2.51-7.977h.049l1.264 4.04H65.87l1.265-4.04zm7.98-.274h1.757c1.025 0 1.668.615 1.668 1.572 0 .978-.609 1.573-1.648 1.573h-1.777V9.749zm0 4.642h1.654L78.608 18h2.337l-2.078-3.917c1.135-.444 1.791-1.538 1.791-2.803 0-1.948-1.299-3.144-3.568-3.144h-4.04V18h2.064v-3.61z","fill":"#fff"}})])
          )
        }
      }
    